import React from 'react';
import ChangeUserPassword from './ChangeUserPassword.jsx';
import { withRouter } from 'react-router-dom';
var axios = require('axios');
var constants = require('../constants/constants');
const trStyle1 = { color: 'gold' }

class UserProfile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userProfileDetail: {},
            isPaneOpen: false,
            isPassword: false,
            isLogout: false,
            showComponent: false,
            UserName: JSON.parse(sessionStorage.getItem("User")).UserName,
            ContactNo: JSON.parse(sessionStorage.getItem("User")).Mobile,
        };
    }

    componentDidMount() {
        let currentComponent = this;
        var user = JSON.parse(sessionStorage.getItem("User"));
        axios.get(constants.config.HOST + constants.api.GET_USER_PROFILE, {
            params: { CompanyId: user.TargetCompanyId, UserId: user.UserId }
            //  params: { CompanyId: 111, UserId: 1 }
        }).then(function (response) {
            currentComponent.setState({ userProfileDetail: response.data })
            console.log(response.data)
        }).catch(function (error) {
            console.log(error);
        });
    }

    changePassword(e) {
        this.setState({
            isPaneOpen: true,
            showComponent: true,
        });
    }

    PasswordInfo(e) {
        this.setState({
            isPassword: true,
        });
        this.props.history.push('/ChangeUserPassword')
    }

    logOut() {
        for (var obj in sessionStorage) {
            if (sessionStorage.hasOwnProperty(obj) && obj == "User") {
                sessionStorage.removeItem(obj);
            }
        }
        this.props.history.push('/Login')
    };

    handleInputChange(e) {
        e.preventDefault();
        var name = e.target.name;
        var state = this.state;
        state[name] = e.target.value;
        this.setState(state);
    }

    render() {
        let currentComponent = this;
        return (
            <div class="pages">
                <div data-page="form" class="page no-toolbar no-navbar">
                    <div class="page-content">

                        <div class="navbarpages navbarpagesbg">
                            <div class="navbar_left">
                                <h2 style={{ 'margin-top': '10px' }} ><b style={{ 'padding-left': '100px' }}>वाहतुकदार</b></h2>
                            </div>
                        </div>
                        <div id="pages_maincontent">
                            <div class="user_thumb">
                                <img src="https://wallpaper-house.com/data/out/6/wallpaper2you_115516.jpg" alt="" title="" />
                                <div class="user_details">
                                    <p style={{ padding: '80px 0 0 0' }}>Welcome,
                                                  <span style={trStyle1}><b style={{ padding: '80px 2px 0 0' }}> {this.state.UserName}</b></span>
                                    </p>
                                </div>
                                <div class="user_avatar">
                                    <img src="https://www.w3schools.com/howto/img_avatar.png" alt="" title="" />
                                </div>
                            </div><br />
                            <h3 style={{ 'color': '#0000FF' }}><b style={{ 'padding-left': '50px' }}>वाहतूकदाराची प्रोफाईल</b></h3>
                            <h4> &nbsp;&nbsp;<b>वाहतूकदाराचे नाव : </b><b style={{ 'color': '#0000FF' }}> {this.state.UserName} </b></h4>
                            <h4>&nbsp;&nbsp;<b>संपर्क नंबर : </b><b style={{ 'color': '#0000FF' }}> {this.state.ContactNo}</b></h4>
                            &nbsp;  <button type="button" onClick={(e) => { this.PasswordInfo(e) }} className="btn btn-primary  btn-flat">पासवर्ड बदला </button>&nbsp;&nbsp;&nbsp;
                              &nbsp;  <button className="btn btn-info" type="button" onClick={(e) => { currentComponent.logOut() }}>LogOut करा </button>
                            <div>
                            </div>
                            {this.state.isPassword ?
                                <ChangeUserPassword /> :
                                null
                            }
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default withRouter(UserProfile)



// WEBPACK FOOTER //
// ./src/component/UserProfile.jsx